const BARCODE_SAMPLE_SUFFIX_LENGTH = 4;

export function buildCocBarcodeContent(casId: string, startDate: string, sampleNumber: string): string {
  const date = startDate.slice(0, 10).replace(/-/g, '');
  const sampleSuffix = sampleNumber.length <= BARCODE_SAMPLE_SUFFIX_LENGTH ? sampleNumber : sampleNumber.slice(-BARCODE_SAMPLE_SUFFIX_LENGTH);
  return `${casId} ${date} ${sampleSuffix}`;
}
